var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgJobs3 = function SvgJobs3(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9261 3.17671L17.3344 5.57838C18.8927 6.26588 18.8927 7.40254 17.3344 8.09004L11.9261 10.4917C11.3119 10.7667 10.3036 10.7667 9.68939 10.4917L4.28105 8.09004C2.72272 7.40254 2.72272 6.26588 4.28105 5.57838L9.68939 3.17671C10.3036 2.90171 11.3119 2.90171 11.9261 3.17671Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.5833C2.75 11.3533 3.3275 12.2424 4.03333 12.5541L10.2575 15.3224C10.7342 15.5333 11.275 15.5333 11.7425 15.3224L17.9667 12.5541C18.6725 12.2424 19.25 11.3533 19.25 10.5833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15.1667C2.75 16.0192 3.25417 16.7892 4.03333 17.1376L10.2575 19.9059C10.7342 20.1167 11.275 20.1167 11.7425 19.9059L17.9667 17.1376C18.7458 16.7892 19.25 16.0192 19.25 15.1667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs3.1e68e377.svg";
export { ForwardRef as ReactComponent };